import slugify from 'slugify';

export default class StringUtils {
	public static firstToLowerCase<T extends string>(str: T) {
		return (str.charAt(0).toLowerCase() + str.slice(1)) as Uncapitalize<T>;
	}

	public static firstToUpperCase<T extends string>(str: T) {
		return (str.charAt(0).toUpperCase() + str.slice(1)) as Capitalize<T>;
	}

	public static slugifyForFilesystem(value: string) {
		return slugify(value, {
			lower: false,
			trim: true,
			strict: false,
			replacement: ' ',
			remove: /[^a-zA-Z0-9\s-_.()]/g,
		});
	}

	public static slugifyForUrl(value: string) {
		return slugify(value, {
			lower: true,
			trim: true,
			strict: true,
		});
	}

	public static splitDisplayName(displayName: string) {
		const nameParts = displayName.split(/\s+/);

		const firstName = nameParts.shift() ?? '';
		const lastName = nameParts.length ? nameParts.join(' ') : '';

		return {
			firstName,
			lastName,
		};
	}
}
